import { render, staticRenderFns } from "./BidDashboardProjects.vue?vue&type=template&id=2dc33204&scoped=true"
import script from "./BidDashboardProjects.vue?vue&type=script&lang=js"
export * from "./BidDashboardProjects.vue?vue&type=script&lang=js"
import style0 from "./BidDashboardProjects.vue?vue&type=style&index=0&id=2dc33204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc33204",
  null
  
)

export default component.exports